import { createMultiStyleConfigHelpers as a } from "@chakra-ui/react";
import { iconSizeStyles as e } from "../foundations/icons.mjs";
import l from "../foundations/z-index.mjs";
const { defineMultiStyleConfig: r } = a([
  "globalNavTopContainer",
  "globalNavNavContainer",
  "globalNavCategory",
  "globalNavCategoryIcon",
  "globalNavMenu",
  "globalNavMenuSlider",
  "globalNavMenuLink",
  "globalNavSubMenu",
  "globalNavSubMenuLink",
  "globalNavMenuDivider"
]), o = 94, b = 334, g = r({
  baseStyle: {
    globalNavTopContainer: {
      minH: "100vh",
      pos: "sticky",
      bg: "teal.500",
      zIndex: l.modal
    },
    globalNavNavContainer: {
      w: `${o}px`,
      h: "full"
    },
    globalNavCategory: {
      w: `${o}px`,
      mx: "auto",
      borderBottom: "1px solid white",
      borderColor: "blackAlpha.200",
      cursor: "pointer",
      display: "block",
      pt: 4,
      px: 2,
      pb: "15px",
      textDecoration: "none",
      "& p": {
        color: "white",
        textStyle: "bodyBoldSmall",
        lineHeight: "20px",
        textAlign: "center"
      },
      _hover: {
        backgroundColor: "white",
        "& p": {
          color: "gray.800"
        },
        "& svg": {
          color: "gray.800"
        }
      },
      _focusVisible: {
        outline: "none",
        boxShadow: "outline",
        backgroundColor: "white",
        "& p": {
          color: "gray.800"
        },
        "& svg": {
          color: "gray.800"
        }
      }
    },
    globalNavCategoryIcon: {
      ...e["2xl"],
      color: "white",
      fill: "currentColor"
    },
    globalNavMenu: {
      m: "6"
    },
    globalNavMenuSlider: {
      overflow: "hidden",
      whiteSpace: "nowrap",
      position: "absolute",
      left: `${o}px`,
      height: "full",
      minHeight: "100%",
      top: "0",
      backgroundColor: "white",
      boxShadow: "18px 28px 24px rgba(0, 0, 0, 0.04)",
      borderRight: "1px solid #D3D4D6",
      zIndex: l.modal
    },
    globalNavMenuLink: {
      textStyle: "bodyBoldSmall",
      color: "green.900",
      textDecoration: "none",
      _hover: {},
      _active: {},
      _focusVisible: {
        outline: "none",
        boxShadow: "outline"
      }
    },
    globalNavSubMenu: {
      mt: "2"
    },
    globalNavSubMenuLink: {
      py: "0.5",
      px: "4",
      textStyle: "bodySmall",
      color: "teal.600",
      textDecoration: "none",
      _hover: {
        backgroundColor: "gray.100",
        borderRadius: "lg",
        color: "teal.700"
      },
      _focusVisible: {
        outline: "none",
        boxShadow: "outline",
        backgroundColor: "gray.100",
        borderRadius: "lg",
        color: "teal.700"
      }
    },
    globalNavMenuDivider: {
      borderColor: "blackAlpha.400"
    }
  },
  variants: {
    disabled: {
      globalNavMenuLink: {
        cursor: "not-allowed",
        opacity: 0.5
      },
      globalNavSubMenuLink: {
        cursor: "not-allowed",
        opacity: 0.5,
        _hover: {
          backgroundColor: "none"
        }
      }
    },
    active: {
      globalNavCategory: {
        backgroundColor: "teal.400",
        boxShadow: "inset 6px 0 #99C7CC",
        "& p": {
          color: "white"
        },
        "& svg": {
          color: "white"
        }
      },
      globalNavMenuLink: {
        pl: "3",
        backgroundColor: "gray.100",
        borderLeftWidth: "4px",
        borderStyle: "solid",
        borderColor: "gray.900"
      },
      globalNavSubMenuLink: {
        backgroundColor: "teal.100",
        color: "teal.700",
        borderRadius: "lg"
      }
    },
    open: {
      globalNavCategory: {
        backgroundColor: "white",
        "& p": {
          color: "gray.800"
        },
        "& svg": {
          color: "gray.800"
        }
      }
    }
  },
  defaultProps: {}
});
export {
  g as default,
  o as globalNavMainWidth,
  b as maxGlobalNavWidth
};
